// @martyrs/src/modules/auth/locales/ru.js
export default {
  auth: {
    // Заголовок раздела входа/регистрации (route.meta.title его роутов).
    title: 'Аутентификация',
    invite: {
      title: 'Приглашение',
    },
    users: {
      title: 'Пользователи',
    },
    profile: {
      title: 'Профиль',
    },
    dashboard: {
      title: 'Дашборд',
    },
    settings: {
      title: 'Настройки',
    },
    // Письмо с кодом подтверждения (otp.service.js). Печатает сервер через
    // translate на языке запроса; {name} — имя бренда, {code} — сам код.
    email: {
      otp: {
        subject: 'Код подтверждения {name}',
        title: 'Ваш код подтверждения',
        text: 'Введите этот код на {name}, чтобы продолжить. Код действует 10 минут.',
        footnote: 'Если вы не запрашивали код, просто проигнорируйте это письмо.',
      },
    },
    // SMS с кодом подтверждения — тот же код другим каналом.
    sms: {
      otp: {
        body: 'Код подтверждения {name}: {code}',
      },
    },
    // Меню профиля пользователя (views/configs/navigation.user.config.js).
    nav: {
      sections: {
        profile: 'Профиль',
        orders: 'Заказы',
      },
      dashboard: 'Дашборд',
      notifications: 'Уведомления',
      settings: 'Настройки',
      profile: 'Профиль',
      account: 'Аккаунт',
      events: 'События',
      groups: 'Группы',
      posts: 'Посты',
      orders: 'Заказы',
    },
    // Настройки профиля (ProfileEditProfile / ProfileEditAccount / сайдбар).
    profileEdit: {
      title: 'Настройки профиля',
      profile: {
        title: 'Профиль',
        uploadUserpic: 'Загрузите аватар',
        usernameHint: 'Имя пользователя станет адресом профиля: /users/<имя>',
        name: 'Имя',
        description: 'Описание',
        notSpecified: 'Не указано',
        socialsTitle: 'Соцсети',
        socialsHint: 'Укажите только имя пользователя, без полной ссылки.',
        save: 'Сохранить',
      },
      account: {
        contactsTitle: 'Телефон и email',
        emailTitle: 'Email',
        phone: 'Телефон',
        phonePlaceholder: 'Введите номер телефона',
        changePhone: 'Изменить телефон',
        savePhone: 'Сохранить телефон',
        email: 'Email',
        emailPlaceholder: 'Введите email',
        changeEmail: 'Изменить email',
        saveEmail: 'Сохранить email',
        cancel: 'Отмена',
        languageTitle: 'Язык',
        language: 'Язык интерфейса',
        countryTitle: 'Страна',
        country: 'Страна',
        countryHint: 'Смена раз в 30 дней',
        settingsTitle: 'Настройки',
        darkmode: 'Тёмная тема',
        accountTitle: 'Аккаунт',
        logout: 'Выйти',
        deleteAccount: 'Удалить аккаунт',
        deleteConfirm: 'Удалить аккаунт? Восстановление возможно только через администратора.',
      },
    },
    popup: {
      title: "Добро пожаловать",
      subtitle: "Войдите или создайте аккаунт для продолжения.",
      signUp: "Регистрация",
      haveAccount: "Уже есть аккаунт?",
      signIn: "Войти"
    },
    signIn: {
      // title — имя страницы (вкладка браузера, крошки), greeting — приветствие
      // на самом экране: это разные тексты, а не два имени одного.
      title: "Вход",
      greeting: "Приветствуем вас,",
      subtitle: "Войдите для продолжения",
      signup: "Нет аккаунта?",
      phone: "Телефон",
      email: "Email",
      phonePlaceholder: "Введите ваш телефон",
      emailPlaceholder: "Введите ваш email",
      haveAccount: "Нет аккаунта? Зарегистрироваться",
      passwordPlaceholder: "Введите ваш пароль",
      forgotPassword: "Забыли пароль?",
      loginByCode: "Войти по коду",
      signin: "Войти",
      signin_apple: "Войти через Apple",
      soon: "СКОРО"
    },
    signUp: {
      title: "Новая учетная запись",
      description: "Выберите удобный способ регистрации через телефон или email:",
      phone: "Телефон",
      email: "Email",
      phonePlaceholder: "Введите ваш телефон",
      emailPlaceholder: "Введите ваш email",
      emailNotice: "Мы отправим вам электронное письмо с кодом подтверждения, который вы должны будете ввести в следующем шаге.",
      smsNotice: "Мы вышлем вам SMS с кодом подтверждения, который вы должны будете ввести в следующем шаге.",
      sendCode: "Отправить код",
      codePlaceholder: "Код из письма",
      back: "Назад",
      home: "На главную",
      haveAccount: "У вас уже есть аккаунт?",
      agreement: "Регистрируясь, вы соглашаетесь с <a href='/legal/eula' target='_blank'>Пользовательским соглашением (EULA)</a>"
    },
    // Сообщения проверок формы на входе, регистрации, сбросе пароля и приглашении.
    validation: {
      phone: 'Некорректный телефон',
      email: 'Некорректный email',
      password: 'Некорректный пароль',
      code: 'Введите код',
      codeFromEmail: 'Введите код из письма',
      // Проверки полей (views/validations/inputs.validation.js).
      length: 'Заполните поле.',
      emailFormat: 'Неверный формат email',
      passwordLength: 'Пароль должен быть не короче 8 символов',
    },
    enterCode: {
      verifyNumberTitle: "Подтвердите номер",
      verifyEmailTitle: "Подтвердите email",
      instructions: "Мы отправили код на ваш номер телефона. Введите его в поле ниже:",
      instructionsEmail: "Мы отправили код на ваш email. Введите его в поле ниже:",
      verifyChangeTitle: "Подтвердите изменение",
      current: "Текущий",
      new: "Новый",
      confirm: "Подтвердить",
      resendCode: "Отправить код еще раз",
      secondsResend: "секунд до возможности отправить код еще раз.",
      resendIn: "Код можно отправить повторно через {n} с"
    },
    resetPassword: {
      title: "Сбросить Пароль",
      forgotPasswordTitle: "Забыли пароль?",
      instructions: "Чтобы сбросить пароль, укажите телефон или email, использованные при регистрации.",
      smsInfo: "Мы вышлем вам SMS с кодом подтверждения для сброса пароля, который вы должны будете ввести в следующем шаге.",
      emailInfo: "Мы отправим вам электронное письмо с кодом подтверждения  для сброса пароля, который вы должны будете ввести в следующем шаге.",
      phone: "Телефон",
      email: "Email",
      phonePlaceholder: "Введите ваш телефон",
      emailPlaceholder: "Введите ваш email",
      sendCode: "Отправить код"
    },
    enterPassword: {
      almostDone: "Почти все!",
      newPasswordPrompt: "Пожалуйста, укажите новый пароль.",
      registrationPasswordPrompt: "Пожалуйста, укажите пароль, на этом регистрация будет закончена.",
      passwordPlaceholder: "Пароль",
      repeatPasswordPlaceholder: "Повторите пароль",
      changePasswordBtn: "Поменять пароль",
      registerBtn: "Зарегистрироваться"
    },
    features: [
      {
        title: "Всё в одном месте",
        description: "Управляйте своим аккаунтом, данными и настройками из единого интерфейса."
      },
      {
        title: "Безопасность по умолчанию",
        description: "Вход по коду и надёжное хранение данных — ваш аккаунт под защитой."
      },
      {
        title: "Быстрый старт",
        description: "Регистрация занимает минуту — и вы сразу приступаете к работе."
      },
      {
        title: "Поддержка рядом",
        description: "Нужна помощь? Мы на связи и готовы ответить на ваши вопросы."
      }
    ]
  }
};